import { ServicesOperations } from '@/components/services';
import { CardBlock } from '@/components/ui';

import styles from './index.module.scss';

export const AboutUs = ({ data }) => {
  return (
    <div
      className={styles.aboutUs}
      itemScope
      itemType='https://schema.org/Organization'
    >
      <div className='wrapper'>
        <ServicesOperations data={data} />
        <CardBlock gridValue={4} data={data} withoutTitle />
      </div>
    </div>
  );
};
